// library imports
import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

// User Component imports
import { PageContent, PageHeader, PageWrapper, PageContainer } from 'components/common/layout_element/LayoutElement';
import * as Constants from "_core/configs/Constants";
import * as LocalStorageUtils from "_core/utils/localstorage";
import {Row, Button, TextInput, Stack, Select, ColorPicker, Icon, Card, Video, Tooltip, Switch, SwitchCheckBox, Text, FlexibleTextInput} from "_core/components/common/UI";
import {InfoCard} from "components/common/parts";
import { setLoading, setMenuState, setErrorModal, setInitializeState, setSceneParam } from "_core/slices/scene/SceneSlice";
import { PreviewIFrame } from "components/admin/parts/PreviewIFrame";

// styles imports
import './AdminUserProfileEdit.scss';
import * as SceneConfig from "_core/configs/SceneConfig";
import AdminUserEditApi from "apis/AdminUserEditApi";

const AdminUserProfileEdit = () => {
    const dispatch = useDispatch();


    const ExecAdminUserEditApi = AdminUserEditApi();

    const defaultConfig = {
        prMovieUrl: "",
        prTalkMovieUrl: "",
    }

    const { tUser } = useSelector((store) => store.transaction);
    const { tAccount } = useSelector((store) => store.transaction);
    const { tAppearanceList } = useSelector((store) => store.transaction);
    const { tAssetList } = useSelector((store) => store.transaction);
    const { initializeState } = useSelector((store) => store.scene);
    const {sceneParam} = useSelector((store) => store.scene);
    const [createdAppearance, setCreatedAppearance] = useState(0);
    const [tag, setTag] = useState("");
    const [jsonPath, setJsonPath] = useState("");

    const [selectedAppearance, setSelectedAppearance] = useState(null);
    const [canUpdateProfile, setCanUpdateProfile] = useState(false);
    const [config, setConfig] = useState(defaultConfig);
    const [isMovieSelect, setIsMovieSelect] = useState(false);
    const [previewUrl, setPreviewUrl] = useState("");
    const [previewUrlTemp, setPreviewUrlTemp] = useState("");
    const [isDrawerOpen, setIsDrawerOpen] = useState(true);
    const [layoutType, setLayoutType] = useState("Desktop");


    useEffect(() => {
        dispatch(setMenuState({ isHeader: false, isMenu: true, isFooter: false, isFullScreen: true }));

        // ローカルストレージからプレビューURLを取得
        const savedPreviewUrl = LocalStorageUtils.GetItem(Constants.LOCALSTORAGE_KEYS.previewUrl);
        if (savedPreviewUrl == null || savedPreviewUrl === "null"){
            setPreviewUrl("")
            setPreviewUrlTemp("")
            LocalStorageUtils.SetItem(Constants.LOCALSTORAGE_KEYS.previewUrl, "");
        }
        if (savedPreviewUrl) {
            setPreviewUrl(savedPreviewUrl)
            setPreviewUrlTemp(savedPreviewUrl)
        }

        if (sceneParam && sceneParam.selectedTAppearance && sceneParam.selectedTAppearance > 0)
        {
            setCreatedAppearance(sceneParam.selectedTAppearance)
        }
    }, [dispatch]);

    useEffect(() => {
        if (! tUser)
        {
            return
        }
        // タグの記載内容を取得
        const currentTag = GetCurrentScriptTag(tUser.last_json_path)
        setJsonPath(tUser.last_json_path)
        setTag(currentTag)
    }, [tUser]);
    
    const handleChangePreviewUrl = () => {
        if (previewUrlTemp) {
            setPreviewUrl(previewUrlTemp)
            LocalStorageUtils.SetItem(Constants.LOCALSTORAGE_KEYS.previewUrl, previewUrlTemp);
        }
        else
        {
            setPreviewUrl("")
            LocalStorageUtils.SetItem(Constants.LOCALSTORAGE_KEYS.previewUrl, "");
        }
    }

    const handleChangePreviewUrlExec = (previewUrlFromWindow) => {
        console.log(previewUrlFromWindow);
        if (previewUrlFromWindow) {
            // setPreviewUrlTemp(previewUrlFromWindow)
            setPreviewUrl(previewUrlFromWindow)
        }
    }

    // IDLE動画変更検知
    const getVideoUrl = (tAssetId) => {
        try {
            const selectedIdleTAsset = tAssetList.find(tAsset => tAsset.id === tAssetId)
            let sasUrl = ""
            let canDelete = false
            if (selectedIdleTAsset)
            {
                sasUrl = selectedIdleTAsset.sas
            }

            // videoUrlを設定
            return sasUrl
        } catch (error) {
            return null
        }
    };

    // 見た目情報の関連情報を全て取得
    const getAssetInfo = (tAppearance) => {
        if (! tAppearance)
        {
            return
        }
        if (! tAssetList)
        {
            return
        }

        const idleTAsset = tAssetList.find(tAsset => tAsset.id === tAppearance.idle_asset)
        const idleSasUrl = getVideoUrl(idleTAsset.id)

        const talkTAsset = tAssetList.find(tAsset => tAsset.id === tAppearance.talk_asset)
        const talkSasUrl = getVideoUrl(talkTAsset.id)

        // 見た目情報に関する情報を収集して一つのオブジェクトとして返却する
        return {
            tAppearance : tAppearance,
            idleTAsset : idleTAsset,
            idleSasUrl : idleSasUrl,
            talkTAsset : talkTAsset,
            talkSasUrl : talkSasUrl,
        }
    }

    // useEffect(() => {
    //     const isUpdate = GetIsUpdateProfile()
    //     setCanUpdateProfile(isUpdate)
    //     updatePreviewContent();
    // }, []);
        
    useEffect(() => {
        if (selectedAppearance !== null) {
            setCanUpdateProfile(true);
        }
        updatePreviewContent();
    }, [selectedAppearance]);

    useEffect(() => {
        if(initializeState !== Constants.INITIALIZE_STATE.allComplete)
        {
            return
        }
        // 初期設定
        if (tUser.last_json_path)
        {
            // タグの記載内容を取得
            const currentTag = GetCurrentScriptTag(tUser.last_json_path)
            setJsonPath(tUser.last_json_path)
            setTag(currentTag)
        }

        UpdateSelectedAppearance(null)

        dispatch(setInitializeState(Constants.INITIALIZE_STATE.pageDataFetchComplete))
    }, [initializeState]);

    useEffect(() => {
        UpdateSelectedAppearance(null)
    }, [createdAppearance]);

    function UpdateSelectedAppearance(response)
    {
        // セレクトボックスの設定

        let targetTAppearanceList = tAppearanceList
        if (response != null && response.t_appearance_list != null)
        {
            targetTAppearanceList = response.t_appearance_list
        }
        let targetTUser = tUser
        if (response != null && response.t_user != null)
        {
            targetTUser = response.t_user
        }

        if (!targetTAppearanceList)
        {
            return;
        }

        // 見た目リスト取得
        let selectedAppearanceTemp = targetTAppearanceList.find(tAppearance => tAppearance.id === targetTUser["t_appearance_id"]);
        if (createdAppearance > 0)
        {
            const tAppearanceId = createdAppearance
            selectedAppearanceTemp = targetTAppearanceList.find(tAppearance => tAppearance.id === tAppearanceId);
            dispatch(setSceneParam({}));
        }

        
        if (selectedAppearanceTemp)
        {
            const assetInfo = getAssetInfo(selectedAppearanceTemp)
            setSelectedAppearance(assetInfo)
        }
        else
        {
            // デフォルトは先頭を取得
            const defaultAppearanceTemp = targetTAppearanceList.length > 0 ? targetTAppearanceList[0] : null;
            const assetInfo = getAssetInfo(defaultAppearanceTemp)
            setSelectedAppearance(assetInfo)
        }
    }

    const AdminUserEditApiRequest = async () => {
        // 編集API

        // 通信中の表示を出す
        dispatch(setLoading(true));

        setCanUpdateProfile(false);

        const requestParams = {
            t_user_id: tUser["id"]
        };

        // 変更箇所のみ、リクエストに含める
        if (selectedAppearance)
        {
            requestParams["t_appearance_id"] = selectedAppearance.tAppearance.id;
        }

        const result = await ExecAdminUserEditApi(requestParams);

        // 通信中の表示を消す
        dispatch(setLoading(false));
        if (result.error || (result.response && result.response.error_code > 0))
        {
            // エラーモーダル表示
            dispatch(setErrorModal({ show: true, text: result.response.error_detail }));
        }

        setCanUpdateProfile(true);
    };

    function GetCurrentScriptTag(replaceStr)
    {
        const tAsset = tAssetList.find(tAsset => tAsset.path === replaceStr)

        if (! tAsset)
        {
            return ""
        }
        
        // 現在の最終作成jsonパスを使ってタグ情報を作成
        const currentTag = Constants.SCRIPT_TAG_BASE_STR.replace(Constants.SCRIPT_TAG_REPLACE_STR, tAsset.sas);
        return currentTag
    }

    // 選択変更時の処理
    const handleChangeMovie = (tAppearance) => {
        const assetInfo = getAssetInfo(tAppearance)
        setSelectedAppearance(assetInfo)
        setIsMovieSelect(false)
    };

    // コピー処理を実装
    const copyScriptTagToClipboard = () => {
        navigator.clipboard.writeText(tag)
            .then(() => {
                window.alert("タグをクリップボードにコピーしました");
            })
            .catch((err) => {

            });
    };

    // プレビューを更新する
    function updatePreviewContent() {
        if (!selectedAppearance)
        {
            return
        }

        setConfig({
            accessKey: tUser.access_key,
            prMovieUrl: selectedAppearance.idleSasUrl,
            prTalkMovieUrl: selectedAppearance.talkSasUrl,
        });
    };

    const editorDrawer = () => {
        return (
            <div className={"block-center margin-bottom-60px editor-drawer-setting " + ((isDrawerOpen && !isMovieSelect) ? "show" : "")}>
                <Stack className="spacing-32px flex-left width-full">
                    <Stack className="spacing-16px">
                        <Stack className="spacing-4px">
                            <div className="text-size-medium text-bold">外見</div>
                            <div className="text-size-small">{Constants.AI_NAME}の外見を選択できます。</div>
                        </Stack>
                        <Row>
                            <Button className="video-button hidden width-full" onClick={() => {setIsMovieSelect(true)}}>
                                <Stack className="height-full width-full">
                                    <Row className="video-label flex-center align-center">
                                        {selectedAppearance && selectedAppearance.tAppearance.name}
                                    </Row>
                                    <Video className="vertical-fit" src={selectedAppearance ? selectedAppearance.idleSasUrl : ""}/>
                                </Stack>
                            </Button>
                        </Row>
                    </Stack>
                </Stack>
            </div>
        )
    }

    const movieSelectComponent = (tAppearance) => {
        const assetInfo = getAssetInfo(tAppearance)
        return (
            <Stack className="movie-select spacing-4px">
                <Button 
                    className={"video-button-row hidden width-full " + ((selectedAppearance && assetInfo.tAppearance.id === selectedAppearance.tAppearance.id) ? "selected" : "")}
                    onClick={() => {handleChangeMovie(tAppearance)}}
                    >
                    <Row className="height-full width-full flex-both">
                        <Stack className="video-label flex-center align-center text-size-normal">
                            {assetInfo.tAppearance.name}
                        </Stack>
                        <Video className="horizontal-fit" src={assetInfo.idleSasUrl}/>
                    </Row>
                    <Stack className="check-mark">
                        <Icon className="label-icon" icon="check" size={20} />
                    </Stack>
                </Button>
            </Stack>
        )
    }

    const editorSelectMovie = () => {
        return (
            <div className={"block-center margin-bottom-60px editor-drawer-movie " + ((isDrawerOpen && isMovieSelect) ? "show" : "")}>
                <Stack className="spacing-16px align-left">
                    <Button className="hidden back-button" onClick={() => {setIsMovieSelect(false)}}>
                        <Row className="flex-left spacing-8px width-full">
                            <Icon className="label-icon" icon="chevron-left" size={18} />
                            <Stack className="flex-center align-center line-adjusted text-normal-weight">
                                戻る
                            </Stack>
                        </Row>
                    </Button>
                    <Stack className="spacing-16px width-full">
                        <Stack className="spacing-4px">
                            <div className="text-size-medium text-bold">外見</div>
                            <div className="text-size-small">{Constants.AI_NAME}の外見を選択できます。</div>
                        </Stack>
                        <Stack className="movie-select-list spacing-16px">
                            {tAppearanceList &&
                                tAppearanceList.map((tAppearance) => (
                                    <div key={tAppearance.id}>
                                        {movieSelectComponent(tAppearance)}
                                    </div>
                                ))
                            }
                        </Stack>
                    </Stack>
                </Stack>
            </div>
        )
    }

    return (
        <PageContent pageId="AdminUserProfileEdit">
            <div className="editor-wrapper">
                <Stack className={"editor-drawer " + (isDrawerOpen ? "expand" : "")}>
                    <Row className={"drawer-header align-center " + (isDrawerOpen ? "flex-right" : "flex-center")}>
                        <Button className={"drawer-close-button hidden flex align-center " + (isDrawerOpen ? "flex-right" : "flex-center")} onClick={() => setIsDrawerOpen(!isDrawerOpen)}> 
                            <Icon icon={isDrawerOpen ? "chevron-left" : "chevron-right"} size={16} />
                        </Button>
                    </Row>
                    {/* ここにページ内コンテンツのコンポーネントを記述 */}
                    <Stack className="drawer-content">
                        {editorSelectMovie()}
                        {editorDrawer()}
                    </Stack>
                </Stack>
                <Stack className="editor-preview">
                    <div className="editor-header">
                        <Row className="flex-both spacing-8px">
                            <Row className="spacing-8px width-50percent">
                                <Stack className="spacing-8px width-full">
                                    <div>プレビューURL</div>
                                    <div className="clipboard-area width-full relative">
                                        <TextInput 
                                            className = "tag-input"
                                            default={previewUrl} 
                                            onchange={(e) => {
                                                setPreviewUrlTemp(e.target.value)
                                            }}
                                            placeholder="https://sample.co.jp"  
                                            isLoading={(initializeState < Constants.INITIALIZE_STATE.pageDataFetchComplete) ? true : false}
                                        />
                                        <Button className={"clipboard-button "+(previewUrlTemp ? "hidden": "hidden disabled")} onClick={handleChangePreviewUrl}><Icon icon="arrow-clockwise" size={20} className="copy-icon"/></Button>
                                    </div>
                                </Stack>
                                <Stack className="flex-bottom">
                                    <Switch
                                        className="layout-switch"
                                        options={
                                            [
                                                { value: "Desktop", icon: "display"},
                                                { value: "SP", icon: "phone"},
                                                { value: "FullScreen", icon: "arrows-fullscreen"},
                                            ]
                                        }
                                        onChange={(value) => {setLayoutType(value)}} 
                                        value={layoutType}
                                    />
                                </Stack>
                            </Row>
                            <Stack className="spacing-32px align-center">
                                <Row className= "width-full align-center spacing-16px flex-left">
                                    <Stack className="spacing-8px">
                                        <div>HTMLタグ</div>
                                        <div className="clipboard-area relative">
                                            <TextInput 
                                                className = "tag-input"
                                                default={tag} 
                                                value = {tag}
                                                placeholder="更新を行うとタグが発行されます"  
                                                disabled={true}
                                                isLoading={(initializeState < Constants.INITIALIZE_STATE.pageDataFetchComplete) ? true : false}
                                            />
                                            <Button className={"clipboard-button "+(tag ? "hidden": "hidden disabled")} onClick={copyScriptTagToClipboard}><Icon icon="copy" size={20} className="copy-icon"/></Button>
                                        </div>
                                    </Stack>
                                    <Stack className="spacing-32px align-center flex-bottom height-full">
                                        <Button
                                            className={"width-120px " + ((canUpdateProfile) ? "primary": "primary disabled")}
                                            onClick={() => AdminUserEditApiRequest()}>
                                            更新
                                        </Button>
                                    </Stack>
                                </Row>
                            </Stack>
                        </Row>
                    </div>
                    {/* プレビュー表示領域 */}
                    <Stack className={"editor-preview-content flex-center align-center " + ((layoutType === "FullScreen") ? "fullscreen": "")}>
                        <Button
                            className={"quit-fullscreen-button"}
                            onClick={() => {setLayoutType("Desktop")}}>
                            <Icon icon={"x"} size={20} />
                            <Text>閉じる</Text>
                        </Button>
                        <PreviewIFrame
                            className={(layoutType === "SP") ? "sp" : ""}
                            config={config}
                            hostName={previewUrl}
                            targetDomain={"https://" + (tUser ? tUser.domain : "")}
                            tag={tag}
                            jsonPath={jsonPath}
                            onURLChanged={(url) => {handleChangePreviewUrlExec(url)}}
                            isLoading={(initializeState < Constants.INITIALIZE_STATE.pageDataFetchComplete) ? true : false}
                        />
                    </Stack>
                </Stack>
            </div>
    </PageContent>
    );
};

export default AdminUserProfileEdit;